<!--
  Wrap a view's existing page-header markup with this to relocate it into the top header bar
  when the sidebar-nav flag is on. Flag off: renders exactly where it was written (teleport
  disabled), so nothing changes for anyone not on the new layout.

  Usage — wrap the block, change nothing inside it:
    <PageHeaderPortal>
      <div class="view-title-container"> ... </div>
    </PageHeaderPortal>

  The target is #header-page-slot, rendered by components/header.vue only in side layout, so
  there's nothing to teleport to (and this is disabled) whenever the flag is off.
-->
<template>
  <teleport to="#header-page-slot" :disabled="!enabled">
    <slot />
  </teleport>
</template>

<script>
import { isSidebarNavEnabled } from "@/helpers/navPrefs.js"

export default {
  name: "PageHeaderPortal",
  data() {
    return { enabled: false }
  },
  created() {
    if (!isSidebarNavEnabled()) return
    // header.vue only renders #header-page-slot when it's actually on screen (side layout,
    // and the current route isn't one of the ones that hide the header entirely — e.g. the
    // LockExtensionLanding email-link view). Sibling mount order guarantees the header (and
    // its slot div) exists before this component's created() runs whenever it IS rendered, so
    // an absent target here means "no header on this route" rather than "not ready yet" —
    // stay disabled and render in place instead of teleporting into nothing.
    if (typeof document !== "undefined" && document.getElementById("header-page-slot")) {
      this.enabled = true
    }
  }
}
</script>
